var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControllerSmall = function SvgIconControllerSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M2.949 13.666q-.506 0-.855-.35a1.16 1.16 0 0 1-.35-.855V3.538q0-.506.35-.855.35-.35.855-.35h8.923q.505 0 .855.35t.35.855v1.385h1.18v1h-1.18V7.5h1.18v1h-1.18v1.577h1.18v1h-1.18v1.384q0 .505-.35.855t-.855.35zm0-1h8.923a.2.2 0 0 0 .14-.064.2.2 0 0 0 .065-.14V3.537a.2.2 0 0 0-.064-.14.2.2 0 0 0-.141-.065H2.949a.2.2 0 0 0-.141.064.2.2 0 0 0-.064.141v8.923q0 .076.064.141t.14.064m1.384-1.59h3.013V8.731H4.333zm3.808-4.474h2.346v-1.68H8.141zM4.333 7.936h3.013V4.923H4.333zm3.808 3.14h2.346V7.397H8.141z"
  })));
};
export default SvgIconControllerSmall;